import { PlusOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { Button } from 'antd';
import { useOpenDrawerHandler } from 'hooks';
import { Drawers } from 'app/types/drawer';
import { Can } from 'components';
import { User } from 'constants/index';
import { Tool } from 'app/types/tool';

const NewToolTest = ({ tool } : { tool : Tool }) => {
  const { t } = useTranslation();

  const handleClick = useOpenDrawerHandler({ key: Drawers.ADD_TOOL_TEST, props: { tool } });

  return (
    <Can requiredPermission={User.Permissions.MANAGE_TOOL_TEST}>
      <Button onClick={handleClick} icon={<PlusOutlined />} type='link'>
        {t('common.addnew')}
      </Button>
    </Can>
  );
};

export default NewToolTest;